/**
 * CSV for Excel in French.
 *
 * Two details decide whether the file opens as a table or as one mangled
 * column: the separator has to be a semicolon, which is what Excel expects
 * under a French locale, and the file has to start with a UTF-8 BOM, without
 * which Excel reads it as Latin-1 and every accent comes out wrong.
 */

const SEPARATOR = ';';
const BOM = '\ufeff';

function escapeCell(value: string): string {
  // Quote whenever a separator, a quote or a newline would otherwise end the
  // field early. Inner quotes double, as the format requires.
  if (/[";\r\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

export function toCsv(rows: readonly (readonly string[])[]): string {
  return BOM + rows.map((row) => row.map(escapeCell).join(SEPARATOR)).join('\r\n');
}

/** Trigger a download, the same way `exportData` does for the JSON backup. */
export function downloadCsv(fileName: string, rows: readonly (readonly string[])[]): void {
  const blob = new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();

  URL.revokeObjectURL(url);
}

/** A file name safe on every filesystem, accents folded away. */
export function slugify(value: string): string {
  return (
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'export'
  );
}
